import React, { useState } from "react";
import GrowthIndexDropdown from "../GrowthIndexDropdown";


const TotalExpenses = (props) => {
    const [annualExpenses, setAnnualExpenses] = useState("")

    function getGrowthIndex(inflation){
        const inflationValue = inflation;
        console.log(inflationValue);
        return inflationValue;
    }

    const onInputChange = (event) => {
        const totalExpense = event.target.value
        setAnnualExpenses(event.target.value)
        props.getTotalExpenseData(totalExpense);
      }

    const onSubmit = (event) => {
        event.preventDefault();
    }

    return (
        <div>
            <div className="total-annual-expenses nunito-semi-bold-boulder-14px">Total Annual Expenses </div>
            <input className="pre-tax-annual-income-input-field border-1px-mischka" 
                onSubmit={onSubmit}
                placeholder="$" 
                type="number"
                name="totalExpenses"
                value={annualExpenses}
                onChange={onInputChange}
                >
            </input>
            <div className="growth-index-lira">Would you like to set growth indexed to inflation?</div>
            <GrowthIndexDropdown getIndexData = {getGrowthIndex} />
        </div>
    )
}

export default TotalExpenses;